// ----------------------------------------
// ページトップに戻るボタン
// ----------------------------------------
(function($) {
  $(window).on('scroll', function() {
    var scrollValue = $(window).scrollTop();
    if (scrollValue > 600) {
      $('#backtotop').fadeIn('normal');
    } else {
      $('#backtotop').fadeOut('fast');
    }
  });
})(jQuery);
